import { render, staticRenderFns } from "./SystemBackup.vue?vue&type=template&id=d4f90a64&scoped=true"
import script from "./SystemBackup.vue?vue&type=script&lang=js"
export * from "./SystemBackup.vue?vue&type=script&lang=js"
import style0 from "./SystemBackup.vue?vue&type=style&index=0&id=d4f90a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f90a64",
  null
  
)

export default component.exports